import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
import auth from "../../../common/utility/auth";

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">


                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="eye"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>
        {/*                     <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={row.idCajaEstado == 1 ? false : true}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip> */}


                  
                            {row.idCajaEstado == 5 && auth.user().id == row.idUsuario ? (

                                <Tooltip placement="top" title={"Cerrar Caja"}>
                                    <Button
                                        type="success"
                                        icon="issues-close"
                                        size={"small"}
                                        onClick={() => props.onViewCierre(row)}
                                    />
                                </Tooltip>

                            ) : null}

                            {row.idCajaEstado == 1 ? (

                                <Tooltip placement="top" title={"Aperturar"}>
                                    <Button
                                        type="success"
                                        icon="check"
                                        size={"small"}
                                        onClick={() => props.onActive(row)}
                                    />
                                </Tooltip>

                            ) : null}


                  {/*           <Tooltip placement="top" title={"Anular"}>
                                <Button
                                    disabled={row.idCajaEstado != 1 ? true : false}
                                    type="danger"
                                    icon="delete"
                                    size={"small"}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip> */}

                       

                            {row.idCajaEstado == 5 || row.idCajaEstado == 4 ? (
                                
                                <Tooltip placement="top" title={"Anexo"}>
                                <Button
                                    type="primary"
                                    icon="check-circle"
                                    size={"small"}
                                    onClick={() => props.onAnexo(row)}
                                />
                            </Tooltip>

                            ) : 
                            <Tooltip placement="top" title={"Anexo"} >
                            <Button
                                type="primary"
                                icon="check-circle"
                                size={"small"}
                                disabled={true}
                                onClick={() => props.onAnexo(row)}
                            />
                        </Tooltip>
                            }

                            {row.idCajaEstado == 5 || row.idCajaEstado == 4 ? (

                                <Tooltip placement="top" title="Imprimir">
                                    <Button
                                        type="primary"
                                        icon="printer"
                                        size={"small"}
                                        loading={props.loadingImprimir}
                                        onClick={() => props.onImprimir(row)}
                                    />
                                </Tooltip>

                            ) : 
                            <Tooltip placement="top" title="Imprimir">
                            <Button
                                type="primary"
                                icon="printer"
                                size={"small"}
                                disabled={true}
                                onClick={() => props.onImprimir(row)}
                            />
                        </Tooltip>
                            }


                        </div>
                    )
                },

                {
                    title: 'Nro Planilla',
                    dataIndex: 'nroSerie_correlativo',
                    key: 'nroSerie_correlativo',
                    sorter: true
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento',
                    sorter: true
                },
                {
                    title: 'Caja',
                    dataIndex: 'caja',
                    key: 'caja',
                    sorter: true
                },
                {
                    title: 'Responsable',
                    dataIndex: 'empleado',
                    key: 'empleado',
                    sorter: true
                },
                {
                    title: 'Fecha Apertura',
                    dataIndex: 'fecha',
                    key: 'fecha',
                    sorter: true,
                    render: (value, row) => (
                        <span>{value} {row.hora}</span>
                    ) 
                },
    
                {
                    title: 'Fecha Cierre',
                    dataIndex: 'fechaCierre',
                    key: 'fechaCierre',
                    sorter: true,
                    render: (value, row) => (
                        <span>{value} {row.horaCierre}</span>
                    ) 
                },
         
                {
                    title: 'Saldo Cierre',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'saldoCierreSoles',
                            key: 'saldoCierreSoles',
                            className: 'parent-group parent-group-2',
        
                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'saldoCierreDolares',
                            key: 'saldoCierreDolares',
                            className: 'parent-group parent-group-2',
        
                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        }
                    ]
                },
    
                {
                    title: 'Estado',
                    dataIndex: 'idCajaEstado',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 1: //registado
                                        return <Tag color={"green"}>{row.cajaEstado}</Tag>;
                                    case 2://ANULADA
                                        return <Tag color={"red"}>{row.cajaEstado}</Tag>;
                                    case 3://APERTURADA
                                        return <Tag color={"green"}>{row.cajaEstado}</Tag>;
                                    case 4://CERRADO
                                        return <Tag color={"red"}>{row.cajaEstado}</Tag>;
                                    case 5://POR CERRAR
                                        return <Tag color={"blue"}>{row.cajaEstado}</Tag>;
                                    default:
                                        return null;
                                }
                            })()}

                        </div>)
                    }
                }
            ]}
        />
    );
}